module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.subNavTitle,
      "ReturnButton": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [(this.capsule === 'draft-edit') ? _c('f7-list', {
    staticClass: "draftTitle"
  }, [_c('f7-list-item', [_c('f7-label', {
    staticClass: "paymentsRequestSubOption formLabel formLabelPayment"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v(_vm._s(_vm.$t('creation_forms.drft_nm')))]), _vm._v(" "), _c('f7-input', {
    staticClass: "paymentsRequestSubOption",
    attrs: {
      "placeholder": "Draft name",
      "type": "text"
    },
    model: {
      value: (_vm.draftName),
      callback: function($$v) {
        _vm.draftName = $$v
      },
      expression: "draftName"
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h6', {
    staticClass: "content-block labelAccordionForm creationFormTitle"
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_out.png")
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.new_item', {
    itemname: _vm.$t('servicesNames.dir_pymnts_sing')
  })) + "\n              ")])]), _vm._v(" "), (_vm.accountType === '1') ? _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.formsSubTitle.val_info')) + "\n                        "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "test-title subtitleDebtorList col-4 col-sm-2 col-form-label labelAccordionForm",
    attrs: {
      "for": "sel1"
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                      " + _vm._s(_vm.$t('common.team_label')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 showSmallScreenOnly form-group",
    class: _vm.colorBottomButton
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "button button-round button-inner-color buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.teamPicker($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.slct')) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 showSmallScreenOnly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.label_team),
      expression: "label_team"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "teamSelect",
      "type": "text",
      "placeholder": "Choose team",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.label_team)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.label_team = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly col-8 col-sm-10"
  }, [_c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1",
      "readonly": "",
      "options": _vm.teamOptions
    },
    model: {
      value: (_vm.id_team),
      callback: function($$v) {
        _vm.id_team = $$v
      },
      expression: "id_team"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.accountType === '1') ? _c('hr') : _vm._e(), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.dir_pymnt_sttngs')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "1.5em"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.readonly,
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.instantPayment),
      callback: function($$v) {
        _vm.instantPayment = $$v
      },
      expression: "instantPayment"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('creation_forms.inst_pymnt_form')) + "\n                        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.readonly,
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.decision),
      callback: function($$v) {
        _vm.decision = $$v
      },
      expression: "decision"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('directPayments.dir_pymnt_decision_form')) + "\n                        ")]), _vm._v(" "), _c('b-form-checkbox', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "disabled": _vm.readonly,
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.isOcrActive),
      callback: function($$v) {
        _vm.isOcrActive = $$v
      },
      expression: "isOcrActive"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.activate_OCR_form')) + "\n                        ")])], 1)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.bnk_trnsfr_ordr')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "col-md-5 col-8",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm longword-word",
    on: {
      "click": function($event) {
        return _vm.openImportAttachment()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('sent.import_bank_order_file')) + "\n                          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.readonly && _vm.isSmartphoneOS) ? _c('div', {
    staticClass: "col-4 scanbutton",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.scanOrder($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('creation_forms.scn_ordr_forms')) + "\n                          ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachementNameLabel),
      expression: "attachementNameLabel"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "placeholder": "Select a file...",
      "readonly": "",
      "id": "application-file-input"
    },
    domProps: {
      "value": (_vm.attachementNameLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachementNameLabel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "id": "recommendation-list-input"
    }
  })])]), _vm._v(" "), ((typeof _vm.attachmentName) !== 'undefined' && _vm.attachmentName !== '') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label labelAccordionForm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.rfrnc')) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachmentReference),
      expression: "attachmentReference"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "readonly": _vm.readonly,
      "placeholder": "Reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.attachmentReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachmentReference = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: " form-group row",
    class: _vm.colorBottomButton
  }, [(_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.hasAttachment) ? _c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.view_attchmnt')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.hasAttachment) ? _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.dwnld_attchmnt')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [((typeof _vm.attachmentName) !== 'undefined' && _vm.attachmentName !== '') ? _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton",
    on: {
      "click": function($event) {
        return _vm.clearAttachement()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.clear_label')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.readonly && _vm.hasAttachment) ? _c('div', {
    staticClass: "row"
  }, [(_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md2"
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.view_attchmnt')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md2"
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.dwnld_attchmnt')))])], 1) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto text-uppercase"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.formsSubTitle.item_info', {
    itemname: _vm.$t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
  })) + "\n                          "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row justify-content-start"
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "col-md-5 col-8",
    class: {
      blueBottomButton: _vm.isOcrActive, greyBottomButton: !_vm.isOcrActive
    }
  }, [_c('input', {
    staticClass: "item-input hiddenElementAllSize rib-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.executeOCROnRIB
    }
  }), _vm._v(" "), _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm",
    attrs: {
      "disabled": !_vm.isOcrActive
    },
    on: {
      "click": function($event) {
        return _vm.importRIB($event)
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('sent.import_RIB_btn', {
    contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
  })) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isOcrActive && _vm.isSmartphoneOS) ? _c('div', {
    staticClass: "col-4 showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm scanbutton",
    on: {
      "click": function($event) {
        return _vm.scanRIB($event)
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('sent.scan_RIB_btn')) + "\n                            ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-8",
    class: _vm.colorBottomButton
  }, [(!_vm.readonly) ? _c('a', {
    attrs: {
      "href": "/directPayments/contactDebtorList/"
    }
  }, [_c('span', {
    staticClass: "button button-round button-inner-color",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('sent.select_cntct_btn', {
    contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
  })) + "\n                              ")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                            " + _vm._s(_vm.$t('common.nme')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beneficiaire),
      expression: "beneficiaire"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "readonly": _vm.readonly,
      "placeholder": "Beneficiary name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.beneficiaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beneficiaire = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm"
  }, [_c('span', [(_vm.mandatoryDebtorEmail) ? _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$t('common.idtfr')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipientEmail),
      expression: "recipientEmail"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "readonly": _vm.readonly,
      "placeholder": "Beneficiary email / siren"
    },
    domProps: {
      "value": (_vm.recipientEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recipientEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.readonly && !_vm.contactSelected) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.account_zone')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 showSmallScreenOnly form-group",
    class: _vm.colorBottomButton
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "button button-round button-inner-color buttonAccordionForm",
    attrs: {
      "placeholder": _vm.$i18n.t('zoneCodes.slct_zone')
    },
    on: {
      "click": function($event) {
        return _vm.countriesPicker($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('zoneCodes.slct_zone')) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 showLargeScreenOnly"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipientZoneCode),
      expression: "recipientZoneCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel4",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.recipientZoneCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: country.id,
      attrs: {
        "disabled": country.disabled
      },
      domProps: {
        "value": country,
        "selected": country.selected
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.$t('zoneCodes.' + country.label)) + "\n                            ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipientZoneCode.accountLabel), function(accountLabel) {
    return _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-4 col-sm-2 col-form-label"
    }, [_c('span', {
      staticClass: "color-red"
    }, [_vm._v("* ")]), _vm._v(_vm._s(_vm.$t(accountLabel)) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-8 col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.recipientZoneCode.values[accountLabel]),
        expression: "recipientZoneCode.values[accountLabel]"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "identifier",
        "type": "text",
        "placeholder": _vm.$i18n.t(accountLabel)
      },
      domProps: {
        "value": (_vm.recipientZoneCode.values[accountLabel])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.recipientZoneCode.values, accountLabel, $event.target.value)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]), _vm._v("\n                              " + _vm._s(_vm.$t('common.formsSubTitle.my_acc_info')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "test-title subtitleDebtorList col-sm-2 col-4 col-form-label labelAccordionForm",
    attrs: {
      "for": "sel2"
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.act')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 showSmallScreenOnly form-group",
    class: _vm.colorBottomButton
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "button button-round button-inner-color buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.accountPicker($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.slct')) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 showSmallScreenOnly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senderBankName),
      expression: "senderBankName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "account-inputDP",
      "type": "text",
      "placeholder": "Choose account",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.senderBankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senderBankName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly col-8 col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senderBank),
      expression: "senderBank"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.senderBank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.slct_an_acc')))]), _vm._v(" "), _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('option', {
      key: bankAccount.id,
      domProps: {
        "value": bankAccount.iban
      }
    }, [_vm._v("\n                              " + _vm._s(bankAccount.name) + " (" + _vm._s(_vm.$engine.bankAccounts.getCurrency(bankAccount.zoneCode)) + ")\n                            ")])
  })], 2)])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [(_vm.directPayments === '1') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto",
    on: {
      "click": function($event) {
        return _vm.hideBlock($event)
      }
    }
  }, [_vm._v(">\n                            "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]), _vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.dir_pymnts_dtls')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]), _vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.pymnts_req_dtls')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm",
    class: {
      redFont: _vm.remittanceInformationColor
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.rsn')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remittanceInformation),
      expression: "remittanceInformation"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "placeholder": "Reason",
      "type": "text"
    },
    domProps: {
      "value": (_vm.remittanceInformation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remittanceInformation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm",
    class: {
      redFont: _vm.executionDateColor
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.date_label')) + "\n                        ")]), _vm._v(" "), (_vm.hasDatePicker === true) ? _c('div', {
    staticClass: "col-8 col-sm-10",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.calendar($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.paymentsDate()) + "\n                        ")]) : _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.executionDate),
      expression: "executionDate"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": "date",
      "placeholder": "Select a date"
    },
    domProps: {
      "value": (_vm.executionDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.executionDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-4 col-form-label labelAccordionForm",
    class: {
      redFont: _vm.amountColor
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                          " + _vm._s(_vm.$t('common.amnt')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "placeholder": _vm.$i18n.t('common.amnt'),
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.senderCurrency))])])])])])])])])]), _vm._v(" "), (_vm.validators.length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.validators.length > 0) ? _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [(_vm.isValidated === '1') ? _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.valid')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron recipientChevron"
  }, [_vm._v("chevron_right")])]) : _c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.formsSubTitle.valid')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron recipientChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, _vm._l((_vm.validators), function(validator) {
    return _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "labelAccordionForm col-6 col-sm-6 col-form-label"
    }, [(validator.idAccount !== '') ? _c('i', {
      staticClass: "fa fa-check",
      staticStyle: {
        "font-size": "16px",
        "color": "green",
        "padding-right": "10px"
      }
    }) : _c('i', {
      staticClass: "fa fa-clock-o streammindBlueFont",
      staticStyle: {
        "font-size": "16px",
        "padding-right": "10px"
      }
    }), _vm._v("\n                          " + _vm._s(validator.groupLabel) + "\n                        ")]), _vm._v(" "), (validator.idAccount !== '') ? _c('div', {
      staticClass: "col-6 col-sm-6 col-form-label labelAccordionForm",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDateTime")(validator.horodatage)))]) : _c('div', {
      staticClass: "col-5 col-sm-5 col-form-label labelAccordionForm",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.$t('creation_forms.pndng')))]), _vm._v(" "), (validator.idAccount !== '') ? _c('span', {
      staticClass: "createInvoiceBand col-12 col-sm-12 col-form-label",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(validator.name))]) : _c('span', {
      staticClass: "createInvoiceBand col-12 col-sm-12 col-form-label",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("---")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.versionNumber > 1) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.versionNumber > 1) ? _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm accordion-item-expanded"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('creation_forms.rfsl_hstr')) + "\n                            "), _c('i', {
    staticClass: "f7-icons formChevron recipientChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "labelAccordionForm col-12 col-sm-12 col-form-label"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('creation_forms.vrsn')) + " "), _c('b', [_vm._v(_vm._s(parseInt(this.versionNumber) - 1))]), _vm._v(" " + _vm._s(_vm.$t('creation_forms.rfsd_by')) + " "), _c('b', [_vm._v(_vm._s(this.refuseUsername))]), _vm._v(" " + _vm._s(_vm.$t('creation_forms.from')) + " "), _c('b', [_vm._v(_vm._s(this.refuseGroupLabel))]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "labelAccordionForm col-12 col-sm-12 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.rsn_ws')) + ":")]), _vm._v(" "), _c('label', {
    staticClass: "labelAccordionForm col-12 col-sm-12 col-form-label"
  }, [_vm._v("\n                          Reason was:\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "labelAccordionForm col-12 col-sm-12 col-form-label"
  }, [_vm._v("\n                          " + _vm._s(this.refuseReason) + "\n                        ")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "col-md"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    class: _vm.savePosition,
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.getNameDraft
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v("\n                " + _vm._s(_vm.$t('creation_forms.sv_rqust')) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [(_vm.printValidateButton) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.refuseDraft
    }
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.refus')) + "\n              ")]) : _vm._e()]), _vm._v(" "), ((_vm.accountType === '2' ||
    ((_vm.clearance === '1' | _vm.clearance === '2') &&
      _vm.isValidated === '1')) || _vm.printValidateButton) ? _c('div', {
    staticClass: "col-md"
  }, [(_vm.accountType === '2' ||
    ((_vm.clearance === '1' | _vm.clearance === '2') &&
      _vm.isValidated === '1')) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop col-md",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.sendDirectPayments
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paper-plane"
  }), _vm._v("\n                " + _vm._s(_vm.$t('creation_forms.snd_rqust')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.printValidateButton) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop col-md",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.valideDraft
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('creation_forms.vldt')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.printValidateButton && _vm.ableToValidateAndSend) ? _c('div', {
    staticClass: "col-md"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop col-md",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.valideAndSendDraft
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paper-plane"
  }), _vm._v("\n                " + _vm._s(_vm.$t('creation_forms.vldt_and_snd')) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })]), _vm._v(" "), _vm._m(1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 showSmallScreenOnly"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "ListCountry",
      "type": "text",
      "placeholder": "Select a zone ...",
      "readonly": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18d3d3d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d3d3d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/DPCreateTemplate.vue
// module id = 1632
// module chunks = 2